/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Packages_TitleInputs */

const vi_trace_packages_title = /** @type {(inputs: Trace_Packages_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đóng gói`)
};

/**

* @param {Trace_Packages_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_packages_title = /** @type {((inputs?: Trace_Packages_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Packages_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_packages_title(inputs)
});